import { config } from '../../config/config.js';

export async function readBlockTaxonomies() {

    const response = await fetch(config.url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query: `
                query {
                    readBlockTaxonomies(
                        blockIdFilter: ` + config.blockId + `
                    )
                    {
                        id
                        name
                        terms
                        {
                            nodes {
                                id
                                name
                                sort
                            }
                        }
                    }
                }
            `,
        }),
    });

    const json = await response.json();

    if (json.data && json.data.readBlockTaxonomies) {

        return json.data.readBlockTaxonomies;

    }

    return false;

}
